import React from "react"
import "./PostsPerPage.scss"
import Select from "@material-ui/core/Select"
import FormControl from "@material-ui/core/FormControl"
import MenuItem from "@material-ui/core/MenuItem"
import {makeStyles} from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  selectBox: {
    width: 68,
    height: "var(--action-item-height)",
    borderRadius: "var(--border-radius)",
    color: "var(--modes-on-primary-container)",
    fontWeight: "var(--font-weight-regular)",
    fontSize: "var(--font-size-paragraph-large)",
    fontFamily: "var(--secondary-font-family)",
    border: "1px solid var(--modes-primary)",
    backgroundColor: "var(--modes-primary-container)",
    boxShadow: "0 1px 1px 0 rgba(221,221,221,0.5)",
    "& .MuiSelect-select:focus": {
      backgroundColor: "var(--modes-primary-container)",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      padding: "6px 16px",
      borderRadius: "var(--border-radius)",
    },
  },
  icon: {
    fill: "var(--modes-on-primary-container)",
    right: "4px",
  },
  menuPaper: {
    "& .MuiMenuItem-root:hover": {
      backgroundColor: "#E9FAF8",
    },
    "& .Mui-selected": {
      backgroundColor: "var(--modes-primary) !important",
    },
    "& .MuiMenuItem-root": {
      marginBottom: "4px",
    },
    "& .MuiMenuItem-root:last-child": {
      marginBottom: "0px",
    },
  },
}))

//PostsPerPage component will render the select box for the per page to change the number of rows to be displayed in the table component

const PostsPerPage = ({selected, perPageHandler, totalRecords}) => {
  const rows = [10, 20, 50]
  const classes = useStyles()

  const displayrows = rows.map((row, index) => {
    return (
      <MenuItem key={index} value={row}>
        {row}
      </MenuItem>
    )
  })

  return (
    <div className="posts-per-page" data-testid="post-per-page-container">
      {/* <span className="row-span">Displaying</span> */}

      <FormControl variant="standard" style={{marginRight: "16px"}}>
        <Select
          id="posts-per-page-select"
          className={classes.selectBox}
          disableUnderline={true}
          inputProps={{
            classes: {
              icon: classes.icon,
            },
            "data-testid": "posts-per-page-select",
          }}
          MenuProps={{
            classes: {
              paper: classes.menuPaper,
            },
          }}
          value={selected}
          onChange={(event) => perPageHandler(event.target.value)}
        >
          {displayrows}
        </Select>
      </FormControl>
      <span className="row-span">per page</span>
    </div>
  )
}
export default PostsPerPage
